import jssVariables from "../../jss_setup";

const htlDetailsHeader = {
  textTransform: "uppercase",
  fontWeight: "bold",
  fontSize: "x-large",
};
export const HotelMeta = {};

export const sliderLclHotelDetails = {
  sliderContainer: {
    background: "#8AB547",
  },
};

export const HotelMetaDescription = {
  Description: {
    background: "#f3f4f9",
    marginTop: jssVariables.double_gap,
  },
  descriptionContr: {
    smallscreen: {
      padding: [0, jssVariables.double_gap],
    },
  },
  header: {
    ...htlDetailsHeader,
    paddingBottom: jssVariables.normal_gap,
  },
};

export const HotelDetailsMapContainer = {
  mapContainer: {
    padding: 0,
  },
};

export const HotelMetaFacilities = {
  facilitiesContr: {
    smallscreen: {
      padding: [0, jssVariables.double_gap],
    },
  },
  header: {
    ...htlDetailsHeader,
    paddingBottom: jssVariables.normal_gap,
  },
};

export const HotelMetaSearchParams = {
  searchParamsContr: {
    smallscreen: {
      padding: [0, jssVariables.double_gap],
    },
  },
  header: {
    textTransform: "uppercase",
    color: jssVariables.colors.base_color,
  },
};

export const roomInlineFilters = {
  inlineFiltersContr: {
    smallscreen: {
      padding: [0, jssVariables.double_gap],
    },
  },
  header: {
    color: jssVariables.colors.base_color,
  },
};

export const roomsList = {
  RoomsList: {
    paddingBottom: `calc(${jssVariables.normal_gap} * 5)`,
    smallscreen: {
      paddingBottom: `calc(${jssVariables.normal_gap} * 5)`,
    },
  },
  header: {
    display: "none",
  },
};
export const RoomGroup = {
  RoomGroup: {
    border: "none",
    boxShadow: jssVariables.shadows.normalShadow,
  },
  header: {
    background: "none",
    color: jssVariables.colors.text.dark,
  },
  roomName: {
    fontSize: "x-large",
  },
};

export const hotelSearchStrip = {
  SearchStripDefault: {
    background: "#dbebc5",
  },
};
